import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

const CHAPTERS = [
  {
    num: "01", title: "Any textbook. Any board.",
    body: "CBSE, ICSE, state boards or university syllabi — if it's printed in English, it can be taught here. Classes 1 to 12, every subject in maths and science, aligned chapter-by-chapter to your exact textbook.",
  },
  {
    num: "02", title: "Engineering, from the floor up.",
    body: "Diploma in Mechanical, degree in Mechanical Engineering — the mentor didn't just study these subjects, he lived them. Thermodynamics, SOM and machine design taught with the intuition only a practitioner has.",
  },
  {
    num: "03", title: "Trading, taught by a trader.",
    body: "No rented Lamborghinis, no screenshot profits. Risk management first, chart reading second, psychology always. The same framework the mentor trades with, handed to you rule by rule.",
  },
  {
    num: "04", title: "An MBA's eye for finance.",
    body: "MBA in Finance means the money side is as rigorous as the engineering side. Valuation, corporate finance and investment analysis taught at postgraduate depth — and priced so students can actually afford it.",
  },
];

export const Manifesto = () => (
  <section id="why" className="border-t border-white/10 px-6 py-24 md:px-12 md:py-32" data-testid="manifesto-section">
    <div className="mx-auto max-w-[1600px]">
      <p className="mb-4 text-xs font-medium uppercase tracking-[0.4em] text-brand">The Manifesto</p>
      <h2 className="mb-24 max-w-3xl font-display text-4xl font-black uppercase leading-none tracking-tighter sm:text-5xl lg:text-6xl">
        Why PP Academy<span className="text-brand">?</span>
      </h2>
      <div className="flex flex-col gap-0">
        {CHAPTERS.map((ch, i) => (
          <motion.div
            key={ch.num}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: EASE }}
            className="grid grid-cols-1 gap-6 border-t border-white/10 py-14 md:grid-cols-12 md:py-20"
            data-testid={`manifesto-chapter-${ch.num}`}
          >
            <div className="md:col-span-4">
              <span className="font-display text-7xl font-black tracking-tighter text-white/10 md:text-9xl">{ch.num}</span>
            </div>
            <div className="md:col-span-8">
              <h3 className="font-editorial text-2xl italic text-zinc-200 md:text-4xl">{ch.title}</h3>
              <p className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-400 md:text-lg">{ch.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
